module.exports = __webpack_public_path__ + "static/media/Белашья 4.e16764c8.jpg";